import React, { useState } from 'react';
import { SearchIcon, ArrowRightIcon } from 'lucide-react';
import { DS } from '../../ds';
import { useBlogContext } from '../../../contexts/BlogContext';
import type { BlogArticle } from '../../../data/blogArticles';
interface ArticleListProps {
  onSelectArticle: (article: BlogArticle) => void;
}
export const ArticleList = ({
  onSelectArticle
}: ArticleListProps) => {
  const {
    articles
  } = useBlogContext();
  const [searchTerm, setSearchTerm] = useState('');
  const filteredArticles = articles.filter(article => article.title.toLowerCase().includes(searchTerm.toLowerCase()) || article.category.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div data-id="element-258" data-mp="m8h6mibgvyfc">
      {/* Buscador */}
      <div style={{
      marginBottom: '36px',
      maxWidth: '420px'
    }} data-id="element-259" data-mp="m9il6wroz31t">
        <div style={{
        position: 'relative'
      }} data-id="element-260" data-mp="h9e16wrkrq6u">
          <SearchIcon size={17} color={DS.color.muted} aria-hidden="true" style={{
          position: 'absolute',
          left: '16px',
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none'
        }} data-id="element-261" data-mp="h82wmuqb2eeo" />
          <input type="text" placeholder="Busca artículos por tema..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} aria-label="Buscar artículos" style={{
          width: '100%',
          padding: '12px 16px 12px 42px',
          border: `1.5px solid ${DS.color.border}`,
          borderRadius: DS.radius.pill,
          fontFamily: DS.font.body,
          fontSize: '14px',
          color: DS.color.ink,
          boxSizing: 'border-box',
          outline: 'none',
          transition: `border-color 0.2s ${DS.ease.smooth}`
        }} onFocus={e => {
          e.currentTarget.style.borderColor = DS.color.aqua;
        }} onBlur={e => {
          e.currentTarget.style.borderColor = DS.color.border;
        }} data-id="element-262" data-mp="1x72ilfqxbyjh" />
        </div>
      </div>

      {/* Grid de artículos */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '28px'
    }} data-id="element-263" data-mp="375u0oc95vs94">
        {filteredArticles.map(article => <article key={article.id} style={{
        background: '#fff',
        border: `1px solid ${DS.color.border}`,
        borderRadius: DS.radius.cardLg,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        transition: `transform 0.3s ${DS.ease.smooth}, box-shadow 0.3s ${DS.ease.smooth}`
      }} onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-6px)';
        e.currentTarget.style.boxShadow = DS.shadow.cardHover;
      }} onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }} data-id="element-264" data-mp="2xdejvi9lp9pt">
            <div style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '4 / 3',
          background: DS.color.linen
        }} data-id="element-265" data-mp="p5j629ilaxz0">
              <img src={article.image} alt={article.title} style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }} data-id="element-266" data-mp="2768caav7win" />
              <span style={{
            position: 'absolute',
            top: '12px',
            left: '12px',
            padding: '4px 10px',
            background: DS.color.aqua,
            borderRadius: '8px',
            fontFamily: DS.font.body,
            fontSize: '11px',
            fontWeight: 700,
            color: DS.color.tealDeep
          }} data-id="element-267" data-mp="6al01y8621bx">
                {article.category}
              </span>
            </div>

            <div style={{
          padding: '22px',
          display: 'flex',
          flexDirection: 'column',
          flex: 1
        }} data-id="element-268" data-mp="2vkq3l4y8n0wo">
              <h2 style={{
            fontFamily: DS.font.heading,
            fontSize: '18px',
            fontWeight: 700,
            color: DS.color.ink,
            lineHeight: 1.35,
            margin: '0 0 10px'
          }} data-id="element-269" data-mp="34kd4lpn224p7">
                {article.title}
              </h2>

              <p style={{
            fontFamily: DS.font.body,
            fontSize: '14px',
            color: DS.color.body,
            lineHeight: 1.6,
            margin: '0 0 18px'
          }} data-id="element-270" data-mp="3sc1vr2o54n4k">
                {article.excerpt}
              </p>

              <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontFamily: DS.font.body,
            fontSize: '12px',
            color: DS.color.muted,
            marginBottom: '18px'
          }} data-id="element-271" data-mp="kp6bfz0xb16m">
                <span data-id="element-272" data-mp="fsfvrct167lq">
                  <strong style={{
                color: DS.color.ink
              }} data-id="element-273" data-mp="1zhtd6i67f8o">
                    {article.author}
                  </strong>
                </span>
                <span data-id="element-274" data-mp="6rhp0mr7jlzg">{article.readTime} min de lectura</span>
              </div>

              <button type="button" onClick={() => onSelectArticle(article)} style={{
            marginTop: 'auto',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '7px',
            width: '100%',
            padding: '11px 16px',
            borderRadius: DS.radius.pill,
            border: 'none',
            background: DS.color.mint,
            color: DS.color.tealDeep,
            fontFamily: DS.font.body,
            fontSize: '13px',
            fontWeight: 700,
            cursor: 'pointer',
            transition: `background-color 0.2s ${DS.ease.smooth}`
          }} onMouseEnter={e => {
            e.currentTarget.style.background = DS.color.aqua;
          }} onMouseLeave={e => {
            e.currentTarget.style.background = DS.color.mint;
          }} data-id="element-275" data-mp="3o7heca6al99c">
                Leer artículo completo
                <ArrowRightIcon size={14} aria-hidden="true" data-id="element-276" data-mp="1un5z3o1av37k" />
              </button>
            </div>
          </article>)}
      </div>

      {filteredArticles.length === 0 && <div style={{
      textAlign: 'center',
      padding: '64px 0',
      fontFamily: DS.font.body,
      fontSize: '15px',
      color: DS.color.muted
    }} data-id="element-277" data-mp="j7r76yny71jb">
          No se encontraron artículos que coincidan con tu búsqueda.
        </div>}
    </div>;
};